// extracted by mini-css-extract-plugin
export var label = "_ky-2";
export var slideContainer = "_ky-0";
export var slider = "_ky-1";